import { Platform } from "react-native";

export const isMobile = () => {
    if (Platform.OS === "android" || Platform.OS === "ios") {
        return true;
    }
    return false;
};